// extracted by mini-css-extract-plugin
module.exports = {"container":"play_container__X3Hug","lg":"play_lg__zd9RP","sm":"play_sm__Y_1bl","active":"play_active__VOsfI","playing":"play_playing__fV1IF"};